import { mergeClasses } from "@fluentui/react-components";
import React from "react";
import { Marker, Popup } from "react-map-gl/maplibre";
import { flightStatus } from "../../../../models/airports/AirportConfig";
import { MAPLIBRE_Z_INDEX } from "../../../../utils/maps/MapConstants";
import FlightMarkerTooltip from "../../../osm-maps/map-markers/flight-markers/FlightMarkerTooltip";
import {
  MARKER_TOOLTIP_PRIORITY,
  useMapTooltip,
} from "../../context/MapTooltipContext";
import { mapLibreStyles } from "../../map-displays/mapStyles";
import { isValidLatLng, toLngLat } from "../../utils/coordinates";
import { getFlightMarkerIconUrl } from "./flightMarkerIcons";

export interface FlightMarkerProps {
  airportCode: string;
  flightNumber: string;
  position: [number, number];
  direction: number;
  flightStatus: flightStatus;
  legType: string;
  selectedFlight: boolean;
  docID: string;
  acType?: string;
  acReg?: string;
  onBlockTime?: string;
  offBlockTime?: string;
  updateMarkerId: (flightID: string, docId: string) => void;
}

const FlightMarker: React.FC<FlightMarkerProps> = ({
  airportCode,
  flightNumber,
  position,
  flightStatus,
  direction,
  legType,
  selectedFlight,
  docID,
  acType,
  acReg,
  onBlockTime,
  offBlockTime,
  updateMarkerId,
}) => {
  const styles = mapLibreStyles();
  const { isTooltipVisible, showTooltip, hideTooltip } = useMapTooltip(
    `flight:${docID || flightNumber}`,
    MARKER_TOOLTIP_PRIORITY
  );

  if (!isValidLatLng(position)) {
    return null;
  }

  const [longitude, latitude] = toLngLat(position);

  return (
    <>
      <Marker
        longitude={longitude}
        latitude={latitude}
        anchor="center"
        rotation={direction - 90}
        rotationAlignment="map"
        pitchAlignment="map"
        style={{ zIndex: MAPLIBRE_Z_INDEX.MARKER }}
      >
        <button
          type="button"
          className={styles.markerButton}
          aria-label={`Flight ${flightNumber}`}
          onClick={() => updateMarkerId(flightNumber, docID)}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          onFocus={showTooltip}
          onBlur={hideTooltip}
        >
          <img
            className={mergeClasses(
              styles.flightMarker,
              selectedFlight && styles.selectedFlightMarker
            )}
            src={getFlightMarkerIconUrl(flightStatus, selectedFlight)}
            alt=""
          />
        </button>
      </Marker>
      {isTooltipVisible && (
        <Popup
          longitude={longitude}
          latitude={latitude}
          anchor="bottom"
          offset={selectedFlight ? 22 : 20}
          closeButton={false}
          closeOnClick={false}
        >
          <FlightMarkerTooltip
            flightNumber={flightNumber}
            airportCode={airportCode}
            legType={legType}
            acType={acType}
            acReg={acReg}
            onBlockTime={onBlockTime}
            offBlockTime={offBlockTime}
          />
        </Popup>
      )}
    </>
  );
};

export default FlightMarker;
